<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><b>T<span class="smallcaps">ABLE OF</span> C<span class="smallcaps">ONTENTS</span></b></span></p>
<table cellpadding="9" cellspacing="9" width="100%;">
<tbody><tr>
<td class="left-a" valign="top"><a href="#/xhtml/introduction"><i>Introduction</i></a></td>
</tr>
</tbody></table>
<p class="hr"></p>
<p class="toc-entry"><a href="#/xhtml/part1"><b>PART I: MADNESS</b></a></p>
<p class="hr"></p>
<table cellpadding="4" cellspacing="4" width="100%;">
<tbody><tr>
<td class="left-a" valign="top"><a href="#/xhtml/chapter01"><i>How to Go to Dinner with a Brother on Drugs</i></a></td>
<td class="right1a" valign="top"><a href="#/xhtml/chapter01">N<span class="smallcaps">ATALIE</span> D<span class="smallcaps">IAZ</span></a></td>
</tr>
<tr>
<td class="left-a" valign="top"><a href="#/xhtml/chapter02"><i>War Cry</i></a></td>
<td class="right1a" valign="top"><a href="#/xhtml/chapter02">S<span class="smallcaps">HERMAN</span> A<span class="smallcaps">LEXIE</span></a></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><i>Bad</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter03" title="Link target outside of Sample">J<span class="smallcaps">ERRY</span> S<span class="smallcaps">TAHL</span></span></td>
</tr>
</tbody></table>
<p class="hr"></p>
<p class="toc-entry"><span href="#/xhtml/part2" title="Link target outside of Sample"><b>PART II: MACHINATION</b></span></p>
<p class="hr"></p>
<table cellpadding="4" cellspacing="6" width="100%;">
<tbody><tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><i>Labiodental Fricative</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter04" title="Link target outside of Sample">S<span class="smallcaps">COTT</span> P<span class="smallcaps">HILLIPS</span></span></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><i>Osito</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter05" title="Link target outside of Sample">K<span class="smallcaps">ENJI</span> J<span class="smallcaps">ASPER</span></span></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter06" title="Link target outside of Sample"><i>Amp Is the First Word in Amphetamine</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter06" title="Link target outside of Sample">J<span class="smallcaps">OSEPH</span> M<span class="smallcaps">ATTSON</span></span></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/addiction" title="Link target outside of Sample"><i>Addiction</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/addiction" title="Link target outside of Sample">J<span class="smallcaps">AMES</span> F<span class="smallcaps">RANCO</span></span></td>
</tr>
</tbody></table>
<p class="hr"></p>
<p class="toc-entry"><span href="#/xhtml/part3" title="Link target outside of Sample"><b>PART III: METHODOLOGY</b></span></p>
<p class="hr"></p>
<table cellpadding="4" cellspacing="6" width="100%;">
<tbody><tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter07" title="Link target outside of Sample"><i>Wheelbarrow Kings</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter07" title="Link target outside of Sample">J<span class="smallcaps">ESS</span> W<span class="smallcaps">ALTER</span></span></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter08" title="Link target outside of Sample"><i>Tips ’n’ Things by Elayne</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter08" title="Link target outside of Sample">B<span class="smallcaps">ETH</span> L<span class="smallcaps">ISICK</span></span></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter09" title="Link target outside of Sample"><i>Pissing in Perpetuity</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter09" title="Link target outside of Sample">R<span class="smallcaps">OSE</span> B<span class="smallcaps">UNCH</span></span></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter10" title="Link target outside of Sample"><i>51 Hours</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter10" title="Link target outside of Sample">T<span class="smallcaps">AO</span> L<span class="smallcaps">IN</span></span></td>
</tr>
</tbody></table>
<p class="hr"></p>
<p class="toc-entry"><span href="#/xhtml/part4" title="Link target outside of Sample"><b>PART IV: MEDICINE</b></span></p>
<p class="hr"></p>
<table cellpadding="4" cellspacing="6" width="100%;">
<tbody><tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter11" title="Link target outside of Sample"><i>Everything I Want</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter11" title="Link target outside of Sample">M<span class="smallcaps">EGAN</span> A<span class="smallcaps">BBOTT</span></span></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter12" title="Link target outside of Sample"><i>The Speed of Things</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter12" title="Link target outside of Sample">J<span class="smallcaps">AMES</span> G<span class="smallcaps">REER</span></span></td>
</tr>
<tr>
<td class="left-a" valign="top"><span href="#/xhtml/chapter13" title="Link target outside of Sample"><i>No Matter How Beautifully It Stings</i></span></td>
<td class="right1a" valign="top"><span href="#/xhtml/chapter13" title="Link target outside of Sample">W<span class="smallcaps">ILLIAM</span> T. V<span class="smallcaps">OLLMANN</span></span></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f968957c